// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class TerceraChartPriceScaleLayoutInfo {
    constructor() {
        this.PreferredWidthScales = 0;
        this.PreferredWidthScalesLeft = 0;
        /// <summary>
        /// Эти условия подразумевают добававление правой шкалы
        /// </summary>
        this.HasOverlays = false;
        this.HasDoubledIndicator = false;
    }
}
